import React from 'react';
import { Helmet } from 'react-helmet';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'primereact/skeleton';
import { parseHtml } from 'utils/htmlParser';
import { programsApi } from 'api';
import SubPageTitle from 'components/_common/panel/SubPageTitle';
import { usePanel } from 'contexts/panelContext';
import { Page } from 'components/_new/Page';

export const Contact = () => {
	const { t } = useTranslation();
	const { currentProgram } = usePanel();

	const { data, isSuccess, isLoading } = useQuery(
		['GET_PROGARM_CONTACT', currentProgram.id],
		() => programsApi.getProgramContact(currentProgram.id),
		{
			enabled: Boolean(currentProgram),
		}
	);

	const hasContent = data && data.length > 0;

	return (
		<>
			<Helmet title={t('userPanel.navigation.contact')} />
			<SubPageTitle title={t('userPanel.navigation.contact')} />
			<Page>
				{isLoading && (
					<>
						<Skeleton width="100%" height="2rem" className="mb-3" />
						<Skeleton width="100%" height="1.5rem" className="mb-2" />
						<Skeleton width="100%" height="1.5rem" className="mb-2" />
						<Skeleton width="80%" height="1.5rem" className="mb-4" />
						<Skeleton width="100%" height="1.5rem" className="mb-2" />
						<Skeleton width="100%" height="1.5rem" className="mb-2" />
						<Skeleton width="60%" height="1.5rem" />
					</>
				)}
				{isSuccess && hasContent && <div className="user-content">{parseHtml(data, { nl2br: false })}</div>}
				{isSuccess && !hasContent && <p>Brak informacji kontaktowych</p>}
			</Page>
		</>
	);
};
